import { useConsent } from '@/lib/consent';
import { isHotjarConfigured } from './client';

/** Whether Hotjar may load: consent allows it and Hotjar is configured for this site (env). */
export const useHotjarEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isHotjarConfigured();
};
